module.exports = __webpack_public_path__ + "static/img/img2.2911dd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/img2.png
// module id = CbCB
// module chunks = 23